import React from 'react';
import { ArrowRight } from 'lucide-react';
export function AboutStrip() {
  return <section id="about" className="py-12 md:py-20 bg-white" data-id="element-18">
      <div className="container mx-auto px-6 md:px-8" data-id="element-19">
        <div className="flex flex-col md:flex-row gap-12 lg:gap-20 items-center" data-id="element-20">
          {/* Left Image */}
          <div className="w-full md:w-1/2 relative" data-id="element-21">
            <div className="aspect-square md:aspect-[4/5] rounded-2xl overflow-hidden relative shadow-soft" data-id="element-22">
              <div className="absolute inset-0 bg-brand-teal/10 z-10 mix-blend-multiply" data-id="element-23"></div>
              <img src="https://cdn.magicpatterns.com/uploads/mFc75rzookLUWZo68uy5wf/bonsai-pool-about.jpg" alt="Crystal clear mosaic-tiled residential pool with ladder" className="w-full h-full object-cover" data-id="element-24" />
            </div>

            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-brand-light rounded-full -z-10 hidden md:block" data-id="element-25"></div>
          </div>

          {/* Right Content */}
          <div className="w-full md:w-1/2" data-id="element-26">
            <div className="text-brand-teal text-sm font-bold tracking-widest uppercase mb-4" data-id="element-27">
              About Bonsai Pool Care
            </div>

            <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-text mb-6" data-id="element-28">
              Owner-operated. Certified. Reliable.
            </h2>

            <div className="space-y-4 text-lg text-brand-muted mb-8" data-id="element-29">
              <p data-id="element-30">
                Bonsai Pool Care is an owner-operated pool maintenance company
                based in Scottsdale, AZ. With 5+ years of hands-on experience
                and a Certified Pool Operator (CPO) certification, we bring
                professional-grade expertise to every visit.
              </p>
              <p data-id="element-31">
                We specialize in residential pools, spas, jacuzzis, and
                fountains across the Northeast Valley. When you book with
                Bonsai, the owner shows up, not a subcontractor.
              </p>
            </div>

            <div className="flex items-center gap-6 mb-8" data-id="element-32">
              <img src="https://cdn.magicpatterns.com/uploads/whZjVRVeAr99DA6EeJdDE7/bonsai-certified.jpg" alt="CPO Certified Pool & Spa Operator badge, Pool & Hot Tub Alliance" className="w-20 h-20 object-contain flex-shrink-0" data-id="element-33" />
              <div data-id="element-34">
                <div className="font-semibold text-brand-text" data-id="element-35">
                  Certified Pool &amp; Spa Operator
                </div>
                <div className="text-sm text-brand-muted" data-id="element-36">
                  Pool &amp; Hot Tub Alliance
                </div>
              </div>
            </div>

            <a href="#contact" className="inline-flex items-center gap-2 text-brand-teal font-semibold hover:text-brand-teal/80 transition-colors group" data-id="element-37">
              Learn more about us
              <ArrowRight size={18} className="transform group-hover:translate-x-1 transition-transform" data-id="element-38" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}